import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { useState } from 'react';
import { ConciergeSmsOptIn } from 'react-concierge-sms';
import { DT } from '../../config/constants';
import { OV_SUBSCRIBE_URL } from '../../config/theme';
import { OV_CONCIERGE_API_KEY } from '../SMSSignUp/constants';
import Button from '../Button';
import css from './ProductWaitlist.module.scss';
import Image from '../Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CONCIERGE_CONFIG = {
  orgName: 'Outdoor Voices',
  header: '',
  subheader: '',
  phonePlaceholder: 'Enter your phone number',
  // TODO: This feature doesn't work currently, contact Concierge
  buttonText: 'Submit',
  successText: '',
  formContainerStyle: {},
  buttonStyle: {},
  buttonDisabledStyle: {
    cursor: 'not-allowed'
  },
  headerStyle: {
    display: 'none'
  },
  subheaderStyle: {
    display: 'none'
  },
  phoneInputStyle: {},
  smsLegalNoticeStyle: {
    display: 'none'
  },
  smsLegalNotice: '',
  onSuccess: function onSuccess() {},
  onError: function onError(error) {
    console.error(error);
  }
};

var Form = function Form(_ref) {
  var disclaimerPreSubmit = _ref.disclaimerPreSubmit,
      disclaimerPostSubmit = _ref.disclaimerPostSubmit,
      isSMSForm = _ref.isSMSForm,
      klaviyoListId = _ref.klaviyoListId,
      source = _ref.klaviyoListSource,
      _ref$success = _ref.success,
      title = _ref$success.title,
      message = _ref$success.message,
      utmCampaign = _ref.utmCampaign;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submitted = _useState4[0],
      setSubmitted = _useState4[1]; // email form props


  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      email = _useState6[0],
      setEmail = _useState6[1];

  var isValid = email !== '';

  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    if (!isValid) return;
    setSubmitting(true);
    fetch(OV_SUBSCRIBE_URL, {
      body: JSON.stringify({
        email: email,
        klaviyo_list_id: klaviyoListId,
        source: source
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }).then(function () {
      return setSubmitted(true);
    }).catch(function (error) {
      return console.error(error);
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!submitted && !isSMSForm && /*#__PURE__*/_jsxs("form", {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/_jsx("label", {
        className: css.label,
        htmlFor: "product-waitlist-email",
        children: /*#__PURE__*/_jsx("input", {
          id: "product-waitlist-email",
          maxLength: 100,
          name: "product-waitlist-email",
          onChange: function onChange(e) {
            return setEmail(e.target.value);
          },
          placeholder: "Enter your email",
          required: true,
          type: "email",
          value: email
        })
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !isValid || submitting,
        type: "submit",
        children: submitting ? DT : 'Submit'
      })]
    }), !submitted && isSMSForm && /*#__PURE__*/_jsx("div", {
      className: css.conciergeForm,
      children: /*#__PURE__*/_jsx(ConciergeSmsOptIn, {
        options: {
          pk: OV_CONCIERGE_API_KEY,
          utm_campaign: utmCampaign
        },
        configuration: _objectSpread(_objectSpread({}, CONCIERGE_CONFIG), {}, {
          onSuccess: function onSuccess() {
            setSubmitted(true);
          }
        })
      })
    }), submitted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h3", {
        className: css.successTitle,
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: css.successMessage,
        children: message
      })]
    }), disclaimerPreSubmit && !submitted && /*#__PURE__*/_jsx("p", {
      className: css.disclaimer,
      dangerouslySetInnerHTML: {
        __html: disclaimerPreSubmit
      }
    }), disclaimerPostSubmit && submitted && /*#__PURE__*/_jsx("p", {
      className: css.disclaimer,
      dangerouslySetInnerHTML: {
        __html: disclaimerPostSubmit
      }
    })]
  });
};

Form.defaultProps = {
  disclaimerPreSubmit: false,
  disclaimerPostSubmit: false,
  isSMSForm: false,
  klaviyoListId: '',
  klaviyoListSource: '',
  utmCampaign: ''
};
Form.propTypes = {
  disclaimerPreSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disclaimerPostSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isSMSForm: PropTypes.bool,
  klaviyoListId: PropTypes.string,
  klaviyoListSource: PropTypes.string,
  success: PropTypes.shape({
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  utmCampaign: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

var ProductWaitlist = function ProductWaitlist(_ref2) {
  var blurb = _ref2.blurb,
      disclaimerPreSubmit = _ref2.disclaimerPreSubmit,
      disclaimerPostSubmit = _ref2.disclaimerPostSubmit,
      imageDesktop = _ref2.imageDesktop,
      imageTablet = _ref2.imageTablet,
      imageMobile = _ref2.imageMobile,
      isSMSForm = _ref2.isSMSForm,
      klaviyoListId = _ref2.klaviyoListId,
      klaviyoListSource = _ref2.klaviyoListSource,
      success = _ref2.success,
      title = _ref2.title,
      utmCampaign = _ref2.utmCampaign;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread({
      className: css.desktop
    }, imageDesktop)), imageTablet && /*#__PURE__*/_jsx(Image, _objectSpread({
      className: css.tablet
    }, imageTablet)), !imageTablet && /*#__PURE__*/_jsx(Image, _objectSpread({
      className: css.tablet
    }, imageDesktop)), /*#__PURE__*/_jsx(Image, _objectSpread({
      className: css.mobile
    }, imageMobile)), /*#__PURE__*/_jsxs("div", {
      className: css.formWrap,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("h3", {
        className: css.blurb,
        children: blurb
      }), /*#__PURE__*/_jsx(Form, {
        disclaimerPreSubmit: disclaimerPreSubmit,
        disclaimerPostSubmit: disclaimerPostSubmit,
        isSMSForm: isSMSForm,
        klaviyoListId: klaviyoListId,
        klaviyoListSource: klaviyoListSource,
        success: success,
        utmCampaign: utmCampaign
      })]
    })]
  });
};

ProductWaitlist.defaultProps = {
  disclaimerPreSubmit: false,
  disclaimerPostSubmit: false,
  isSMSForm: false,
  klaviyoListId: '',
  klaviyoListSource: '',
  utmCampaign: ''
};
ProductWaitlist.propTypes = {
  blurb: PropTypes.string.isRequired,
  disclaimerPreSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disclaimerPostSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  imageDesktop: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageTablet: PropTypes.shape(_objectSpread({}, Image.propTypes)),
  imageMobile: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  isSMSForm: PropTypes.bool,
  klaviyoListId: PropTypes.string,
  klaviyoListSource: PropTypes.string,
  success: PropTypes.shape({
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  utmCampaign: PropTypes.string
};
export default ProductWaitlist;